import { useState } from 'react'
import { cn } from '../utils/cn'

export default function CardServicosCompacto({
  title,
  text,
  icon,
  iconHover,
  glowColor = '#422776',
  url,
  width,
  height,
  iconBgColor,
  origin,
  className,
}) {
  const [isHovered, setIsHovered] = useState(false)

  function handleMouseEnter() {
    setIsHovered(true)
  }

  function handleMouseLeave() {
    setIsHovered(false)
  }

  const CardContent = () => (
    <div
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onTouchStart={handleMouseEnter}
      onTouchEnd={handleMouseLeave}
      className="relative mb-4 md:mb-0 hover:cursor-pointer"
    >
      <div
        className={`absolute inset-0 transition-opacity duration-300 blur-sm md:blur-xl ${
          isHovered ? 'opacity-40 md:opacity-60' : 'opacity-0'
        }`}
        style={{ backgroundColor: glowColor }}
      />
      <div
        className={cn(
          'relative z-10 h-[350px] w-[350px] rounded-lg p-4 bg-[#1B182D] text-white flex flex-col items-center',
          width && `w-[${width}px]`,
          height && `h-[${height}px]`,
          className,
        )}
      >
        {/* Icon at the top */}
        <div className="relative w-[58px] h-[58px] mx-auto mt-2">
          <div
            className={`absolute inset-0 rounded-full transition-all duration-300 ${
              isHovered && origin !== 'finops'
                ? 'bg-gradient-to-r from-[#4B3BDB] via-[#A002CB] to-[#FC0021] opacity-100'
                : 'bg-white/10 blur-[2px]'
            }`}
          />
          <div
            className={`absolute inset-[2px] rounded-full ${iconBgColor ? `bg-[${iconBgColor}]` : 'bg-[#1B182D]'} flex items-center justify-center`}
          >
            <img className="w-7 h-7 object-contain" src={icon} alt={title} />
          </div>
        </div>
        {/* Text content pushed down with margin-top */}
        <div className="mt-4 text-center">
          <h1 className="font-inter-bold text-[22px] text-center">{title}</h1>
          {text && (
            <p className="font-inter-light text-[18px] text-center mt-2">
              {text}
            </p>
          )}
        </div>
      </div>
    </div>
  )

  return url ? (
    <a href={url} className="block no-underline text-inherit">
      <CardContent />
    </a>
  ) : (
    <CardContent />
  )
}
